import { InjectionToken, Provider } from '@angular/core';
import { ILogger } from '../models/ILogger';
import { ITransporter } from '../models/ITransporter';
import { HttpClient } from '@angular/common/http';
import { ConsoleTransporter } from './implementations/ConsoleTransporter';
import { HttpTransporter } from './implementations/HttpTransporter';
import { TransportTemplate } from './TransportTemplate';
import { SlackTransporter } from './implementations/SlackTransporter';
import { SlackNotificationService } from '../../../services/slack-notification.service';
import { LoggerService } from '../logger.service';
import { ILoggerConfiguration } from '../models/ILoggerConfiguration';
import { LogLevel } from '../models/LogLevel';

const DefaultTransportTemplateFn: TransportTemplate<any> = (data: any) => {
    return data;
};

/**
 * Http Transporter Factory
 */
export function MyHttpTransporterFactory(httpClient: HttpClient) {
    /*
     * Make Transporter Template and config
     * just remember this fn receives a CapturedPayload and returns whatever
     * you define if your template requires more deps then you also need to
     * provide another factory and include it in the deps array like httpClient
     */
    const template = DefaultTransportTemplateFn;
    /* any extra config you need */
    const config = { url: 'localhost:3214/test' };
    // create and return the transporter
    return new HttpTransporter(template, httpClient, config);
}

/**
 * Console Transporter Factory
 */
export function MyConsoleTransporterFactory() {
    return new ConsoleTransporter();
    // template is optional for console transporter but
    // if you want to keep constency also at console log
    // then you can do:
    // const template = MyTransportTemplateFn;
    // return new ConsoleTransporter(template);
}

/**
 * Transporter factory to send message to slack
 * @param httpClient
 * @returns
 */
export function SlackTransporterFactory(httpClient: HttpClient, slackNotificationService: SlackNotificationService) {
    const template = DefaultTransportTemplateFn;
    return new SlackTransporter(template, httpClient, slackNotificationService);
}

/**
 * A loggerService that'll send all the messages to a separate ipex channel.
 * @param httpClient 
 * @returns 
 */
export function AdminLoggerFactory(httpClient: HttpClient): ILogger {
    const template = DefaultTransportTemplateFn;
    var adminSlackNotificationService = new SlackNotificationService(httpClient, 'SlackAdminWebHookUrl');
    var adminSlackTransporter = new SlackTransporter(template, httpClient, adminSlackNotificationService);
    return new LoggerService({ level: LogLevel.Info }, [adminSlackTransporter]);
}
